module.exports = (context) => {

    const selectors = context.selectors.all;
    const redux = context.redux.hooks;

    const getAuthStatus = () => selectors.getAuthStatus(redux.getState());
    const hasAuthFinished = () => getAuthStatus() === selectors.AUTH_STATUSES.FINISHED;
    const getIsAuthenticated = () => selectors.getIsAuthenticated(redux.getState());
    const getIsVerified = () => selectors.getVerifiedStatus(redux.getState());
    const getMainAppLoading = () => selectors.getMainAppLoading(redux.getState());
    const hasCurrentUser = () => selectors.hasCurrentUser(redux.getState());
    const hasCurrentSchool = () => selectors.hasCurrentSchool(redux.getState());

    const isResolved = () => {

        if (!hasAuthFinished()) {
            return false;
        }

        if (!getIsAuthenticated()) {
            return true;
        }

        if (!getIsVerified()) {
            return true;
        }

        if (hasCurrentUser() && hasCurrentSchool()) {
            return true;
        }

        // Bootstrap error recovery can preserve the auth session while clearing
        // the app-level loader. In that case, let the route mount so its own
        // dependency handling can show an error/retry instead of waiting forever.
        return !getMainAppLoading();
    };

    const getResolutionValue = () => getIsAuthenticated() ? undefined : 'Not authenticated';

    return {
        // Wait only for browser auth status. App routes use this to kick off
        // main-app bootstrap instead of waiting forever for current user/current school.
        resolveAuthStatus: () => {

            if (hasAuthFinished()) {
                return Promise.resolve(getResolutionValue());
            }

            return new Promise((resolve) => {

                const stop = redux.subscribe(() => {

                    if (hasAuthFinished()) {
                        stop();
                        return resolve(getResolutionValue());
                    }
                });
            });
        },
        // Wait for user to be logged-in then current user fetched, otherwise for auth failure
        resolveIsAuthenticated: () => {

            if (isResolved()) {
                return Promise.resolve(getResolutionValue());
            }

            return new Promise((resolve) => {

                const stop = redux.subscribe(() => {

                    if (isResolved()) {
                        stop();
                        return resolve(getResolutionValue());
                    }
                });
            });
        }
    };
};
